export const getAltText = (offer) => offer?.brand?.name ?? ''
